<template>
  <v-app>
    <alert v-show="!aceitouCookies" v-on:fechar-modal-Alert="Aceite()"/>
    <router-view />
    <notifications position="bottom right" />
    <!-- <app-footer/> -->
  </v-app>
</template>

<script>
import AppFooter from './components/footer/AppFooter.vue'
import Alert from './components/modais/alert.vue'

export default {
  components: {
    // AppFooter,
    Alert
  },
  data () {
    return {
      aceitouCookies: false
    }
  },
  methods: {
    Aceite () {
      this.aceitouCookies = true
      localStorage.setItem('cotrivendasCookies', true)
    }
  },
  mounted () {
    if (localStorage.getItem('cotrivendasCookies') != null) {
      this.aceitouCookies = localStorage.getItem('cotrivendasCookies')
    }
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Nunito:ital,wght@0,200;0,300;0,400;0,800;1,300&family=Roboto:ital,wght@0,300;0,400;0,500;1,400&display=swap');
#app {
  font-family: 'Nunito', sans-serif;
  text-align: center;
  h1, h2, h3, h4 {
    font-family: 'Roboto', sans-serif;
  }
}
a:link
{
  text-decoration-color: yellow;
  text-decoration:none;
}

  span label {
    margin-top: 1rem;
    display:block;
    text-align:left;
  }
  input {
    height: 2rem;
    border: 3px solid #C2171A;
    border-radius: 10px;
  }
  input:hover {
    border: 3px solid #8a0c0e;
  }
  textarea:focus, input:focus, select:focus {
    box-shadow: 0 0 0 0;
    outline: 0;
    border: 3px solid #8a0c0e;
  }
  legend {
    margin-top: 3px;
    display:block;
    text-align:left;
    color: #8a0c0e;
    font-size: 0.5rem;
  }
</style>
